/* ==========================================================================
   OLIVY — Custom Sort-by dropdown (catalog)
   Progressive enhancement: replaces the native <select name="sort_by"> with an
   animated, brand-styled listbox while keeping the original <select> in the DOM
   so Dawn's facet-filters-form sort logic still works (we dispatch `change`).
   Re-runs automatically after Dawn re-renders the facets (MutationObserver),
   and owns its own open/close state — so there's no stuck "focused" appearance.
   ========================================================================== */
(function () {
  if (window.__olivySortInit) return;
  window.__olivySortInit = true;

  var openRoot = null;

  function close(root) {
    if (!root) return;
    root.classList.remove('is-open');
    var btn = root.querySelector('.olivy-sort__button');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (openRoot === root) openRoot = null;
  }

  function open(root) {
    if (openRoot && openRoot !== root) close(openRoot);
    root.classList.add('is-open');
    var btn = root.querySelector('.olivy-sort__button');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    openRoot = root;
  }

  function toggle(root) {
    if (root.classList.contains('is-open')) close(root);
    else open(root);
  }

  function optionEls(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.olivy-sort__option'));
  }

  function focusOption(root, idx) {
    var opts = optionEls(root);
    if (!opts.length) return;
    idx = (idx + opts.length) % opts.length;
    opts[idx].focus();
  }

  function selectOption(root, select, li, labelEl) {
    select.value = li.dataset.value;
    labelEl.textContent = li.textContent;
    optionEls(root).forEach(function (o) {
      o.setAttribute('aria-selected', o === li ? 'true' : 'false');
    });
    close(root);
    var btn = root.querySelector('.olivy-sort__button');
    if (btn) btn.focus();
    // Let Dawn's facet-filters-form handle the actual sort. Dawn listens for
    // `input` on the form (facets.js), so fire that; `change` for good measure.
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function enhance(select) {
    if (!select || select.dataset.olivySort === 'done') return;
    select.dataset.olivySort = 'done';

    var wrapper = select.closest('.select') || select;

    var root = document.createElement('div');
    root.className = 'olivy-sort';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'olivy-sort__button';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML =
      '<span class="olivy-sort__label"></span>' +
      '<svg class="olivy-sort__caret" viewBox="0 0 12 12" width="12" height="12" fill="none" aria-hidden="true">' +
      '<path d="M2.5 4.5L6 8l3.5-3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var labelEl = btn.querySelector('.olivy-sort__label');
    var selectedOpt = select.options[select.selectedIndex];
    labelEl.textContent = selectedOpt ? selectedOpt.textContent.trim() : '';

    var panel = document.createElement('ul');
    panel.className = 'olivy-sort__panel';
    panel.setAttribute('role', 'listbox');

    Array.prototype.forEach.call(select.options, function (opt) {
      var li = document.createElement('li');
      li.className = 'olivy-sort__option';
      li.setAttribute('role', 'option');
      li.tabIndex = -1;
      li.dataset.value = opt.value;
      li.textContent = opt.textContent.trim();
      li.setAttribute('aria-selected', opt.selected ? 'true' : 'false');
      li.addEventListener('click', function () {
        selectOption(root, select, li, labelEl);
      });
      li.addEventListener('keydown', function (e) {
        var opts = optionEls(root);
        var i = opts.indexOf(li);
        if (e.key === 'ArrowDown') { e.preventDefault(); focusOption(root, i + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); focusOption(root, i - 1); }
        else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectOption(root, select, li, labelEl); }
        else if (e.key === 'Escape') { e.preventDefault(); close(root); btn.focus(); }
        else if (e.key === 'Tab') { close(root); }
      });
      panel.appendChild(li);
    });

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggle(root);
      if (root.classList.contains('is-open')) {
        var sel = panel.querySelector('.olivy-sort__option[aria-selected="true"]') ||
          panel.querySelector('.olivy-sort__option');
        if (sel) setTimeout(function () { sel.focus(); }, 0);
      }
    });

    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (!root.classList.contains('is-open')) open(root);
        focusOption(root, 0);
      } else if (e.key === 'Escape') {
        close(root);
      }
    });

    root.appendChild(btn);
    root.appendChild(panel);

    wrapper.classList.add('olivy-sort__native-hidden');
    wrapper.parentNode.insertBefore(root, wrapper.nextSibling);
  }

  function enhanceAll() {
    var selects = document.querySelectorAll('select[name="sort_by"]');
    for (var i = 0; i < selects.length; i++) enhance(selects[i]);
  }

  document.addEventListener('click', function (e) {
    if (openRoot && !e.target.closest('.olivy-sort')) close(openRoot);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openRoot) close(openRoot);
  });

  function init() {
    enhanceAll();
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          enhanceAll();
          return;
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
